import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import './styles.scss';
import RolesSection from '../RolesSection/RolesSection';

const Roles = () => {
  return (
    <div className='marketing-roles'>
      <div className="role-head">
            What Digital Marketing Roles will you get placed in?
      </div>
      <StaticImage src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m1t5vrsy.webp" alt="underline" className="y-underline" />
     
      <div id="roles-section" className="section">
        <RolesSection />
      </div>

    </div>
  );
};

export default Roles;